import {$authHost} from "./index";

const setGuestId = (data) => {
    if (data.guestSessionId) {
        localStorage.setItem('guestSessionId', data.guestSessionId);
    }
};

const DATA_CONSENT_KEY = 'opd_consent_accepted';

// 2. ХОЗЯИН/ГОСТЬ: Отправка последующего сообщения
export const replyMessage = async ({chatSessionId, content}) => {
    try {
        const {data} = await $authHost.post('api/chat/message/reply', {chatSessionId, content});
        setGuestId(data);
        return data;
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка при отправке сообщения';
        throw new Error(msg);
    }
}

// 3. Получение истории чата
export const getChatHistory = async (chatSessionId) => {
    try {
        const {data} = await $authHost.get(`api/chat/history/${chatSessionId}`);
        setGuestId(data);

        // 🟢 НОВАЯ ЛОГИКА СИНХРОНИЗАЦИИ ОПД (Шаг 1)
        if (data.session && data.session.opdConsentAccepted) {
            // Если сервер подтвердил согласие, устанавливаем флаг локально
            localStorage.setItem(DATA_CONSENT_KEY, 'true');
        } else {
            // Если сервер не подтвердил или это новый чат, сбрасываем флаг
            localStorage.removeItem(DATA_CONSENT_KEY);
        }

        return data; // { session, messages }
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка при получении истории чата';
        throw new Error(msg);
    }
}

// 4. ХОЗЯИН: Получение всех активных лидов/сессий
export const getOwnerSessions = async () => {
    try {
        const {data} = await $authHost.get('api/chat/sessions/owner');
        setGuestId(data);
        return data; // массив сессий
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка при получении сессий владельца';
        throw new Error(msg);
    }
}

// 1. Создание чата
export const createOrGetChat = async (addId) => {
    const {data} = await $authHost.post('/api/chat/createOrGet', {addId});
    setGuestId(data);
    return data;
};

// 5. Установка сообщений в статус "Прочитано"
export const readMessages = async (chatSessionId) => {
    try {
        const { data } = await $authHost.post('api/chat/readMessages', { chatSessionId });

        // Обычно этот запрос возвращает статус (например, { success: true, count: 5 }),
        // но здесь мы просто возвращаем данные для подтверждения.
        return data;
    } catch (e) {
        console.error("Ошибка при пометке сообщений как прочитанных:", e.response?.data?.message || e.message);
        throw e;
    }
}

// 6. ✅ Запись согласия на обработку персональных данных (ОПД)
export const recordOPDConsent = async (chatSessionId) => {
    try {
        const {data} = await $authHost.post('api/chat/consent', {chatSessionId});

        // 🟢 НОВАЯ ЛОГИКА (Шаг 2)
        // После успешной записи на сервере, устанавливаем флаг локально
        localStorage.setItem(DATA_CONSENT_KEY, 'true');

        setGuestId(data); // Хотя здесь guestSessionId обычно нет, оставим для чистоты

        return data;
    } catch (e) {
        const msg = e.response?.data?.message || 'Ошибка сервера при фиксации согласия ОПД.';
        throw new Error(msg);
    }
}

//ADMIN
export const getAdminChatSessions = async ({ page = 1, limit = 30, search = '' } = {}) => {
    const { data } = await $authHost.get('api/chat/admin/sessions', {
        params: { page, limit, search }
    });
    return data;
};

export const getAdminChatHistory = async (chatSessionId) => {
    const { data } = await $authHost.get(`api/chat/admin/history/${chatSessionId}`);
    return data;
};
